import { css } from "@emotion/react";

import {
  introTopCaption,
  introMiddleCaption,
  introBottomSubTitle,
} from "../../txts/intro-txts";

type Props = {
  title: string;
};

const Introduction: React.FC<Props> = ({ title }) => {
  return (
    <div id="intro" css={mainStyle}>
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>{title}</div>
          <div css={borderStyle}></div>
        </div>
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/intro-top-txt.png"}
          css={topTxtImgStyle}
        />
        <img
          src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/intro-img.jpg"}
          css={[topTxtImgStyle, marginTopStyle(20)]}
        />
        <div css={[captionStyle, marginTopStyle(12)]}>{introTopCaption}</div>
        <div css={[captionStyle, marginTopStyle(16)]}>{introMiddleCaption}</div>
        <div css={[subTitleStyle, marginTopStyle(16)]}>
          {introBottomSubTitle}
        </div>
      </div>
    </div>
  );
};

const contentsMaxWidth = 750;
const spSize = 768;

const mainStyle = css`
  width: 100%;
`;

const contentsWrapper = css`
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const upperTitleWrapperStyle = css`
  width: 85%;
  max-width: 1125px;
  display: flex;
  align-items: center;
  padding: 30px;

  @media (max-width: ${spSize}px) {
    padding: 30px 20px 10px;
    padding-bottom: 10px !important;
  }
`;

const borderStyle = css`
  height: 3px;
  background-color: white;
  flex-grow: 1;
`;

const titleStyle = css`
  padding: 0 15px;
  font-family: MyFont;
  font-size: 23px;
  font-weight: 500;
  line-height: 100%;

  @media (max-width: ${spSize}px) {
    font-size: 18px;
  }
`;

const topTxtImgStyle = css`
  width: 85%;
  max-width: ${contentsMaxWidth}px;
  height: auto;
`;

const marginTopStyle = (num: number) => css`
  margin-top: ${num}px;
`;

const captionStyle = css`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 15px;
  white-space: pre-wrap;
  font-weight: bold;

  @media (max-width: ${spSize}px) {
    padding: 0 5px;
    padding-bottom: 5px;
    font-size: 9px;
  }
`;

const subTitleStyle = css`
  font-family: "Noto Sans JP", sans-serif;
  font-size: 14px;
  white-space: pre-wrap;
  font-weight: bold;

  @media (max-width: ${spSize}px) {
    font-size: 10px;
  }
`;

export default Introduction;
